import { useState, useEffect } from "react";
import NotificationItem from "examples/Items/NotificationItem";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCartOutlined";
import Badge, { badgeClasses } from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import fetchData from "verticales/FetchData";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";
import { useNavigate } from "react-router-dom";

const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -12px;
    right: -6px;
  }
`;

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";
const context = "ec2-notificaciones";
function MenuAlertasNotificaciones({ absolute, light, isMini }) {
  const [openMenu, setOpenMenu] = useState(false);
  const [data, setData] = useState([]);
  const [instanceId, setInstanceId] = useState(null);
  const navigate = useNavigate();

  const [controller, dispatch] = useMaterialUIController();
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const { transparentNavbar, darkMode } = controller;

  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  useEffect(() => {
    const alertasNotifications = async () => {
      try {
        const params = {
          action: "notificacion",
        };
        const resp = await fetchData(url, context, params);
        const objResp = JSON.parse(resp);
        if (objResp && objResp.rowCount && objResp.rowCount > 0) {
          console.log("...............................", objResp.rows);
          setData(objResp.rows);
        }
      } catch (err) {
        console.error("Error al hacer polling", err);
      }
    };
    alertasNotifications(); // Ejecuta una vez al montar
    const interval = setInterval(alertasNotifications, 30000); // Cada 5 segundos
    return () => clearInterval(interval); // Limpia el intervalo al desmontar
  }, []);

  const handleItemClick = (selectedItemData) => {
    console.log("item seleccionado:", selectedItemData);
    setInstanceId(selectedItemData);

    if (selectedItemData) {
      navigate(`/deep-client?instance_id=${selectedItemData}`);
    }
  };

  const renderMenu = (data) => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      {data.map((datos, index) => (
        // <li key={index}>{nombre}</li>
        <NotificationItem
          key={index}
          icon={<Icon>email</Icon>}
          title={
            datos.instance_id +
            " -- " +
            datos.instance_name +
            " ip:" +
            datos.ip_publica +
            " cpu " +
            datos.cpu +
            " ram " +
            datos.ram
          }
          descripction={"ip" + datos.ip_publica}
          onClick={() => handleItemClick(datos.instance_id)}
        />
      ))}
      {/* <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" /> */}
    </Menu>
  );

  return (
    <>
      <IconButton
        size="small"
        disableRipple
        color="inherit"
        sx={navbarIconButton}
        aria-controls="notification-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={handleOpenMenu}
      >
        <Icon sx={iconsStyle}>notifications</Icon>
        <CartBadge badgeContent={data.length} color="primary" overlap="circular" />
      </IconButton>
      {/* <h1>{data.length}</h1> */}
      {renderMenu(data)}
    </>
  );
}

// Setting default values for the props of DashboardNavbar
MenuAlertasNotificaciones.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
MenuAlertasNotificaciones.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default MenuAlertasNotificaciones;
